import { Fragment, useEffect, useState } from 'react';
import { Col } from 'reactstrap';
import { AlignCenter } from 'react-feather';
import { Link } from 'react-router-dom';
import logo from '@/assets/images/logo/logo.png';
import logoDark from '@/assets/images/logo/logo_dark.png';
import { useTheme } from '../ThemeContext';

/** CUBA Leftbar — header logo + mobile sidebar toggle */
export function Leftbar() {
  const { toggleIcon, toggleSidebar } = useTheme();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const update = () => setIsMobile(window.innerWidth <= 991);
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  const responsiveOpenCloseSidebar = () => {
    if (window.innerWidth <= 991) {
      toggleSidebar(false);
      document.querySelector('.bg-overlay1')?.classList.add('active');
    } else {
      toggleSidebar(!toggleIcon);
    }
  };

  return (
    <Fragment>
      <Col className="header-logo-wrapper col-auto p-0" id="out_side_click">
        <div className="logo-wrapper">
          <Link to="/">
            <img className="img-fluid for-light" src={logo} alt="RCATS" />
            <img className="img-fluid for-dark" src={logoDark} alt="RCATS" />
          </Link>
        </div>
        <div
          className="toggle-sidebar"
          onClick={responsiveOpenCloseSidebar}
          role="button"
          tabIndex={0}
          style={{ display: isMobile ? 'block' : 'none' }}
        >
          <AlignCenter className="status_toggle middle sidebar-toggle" id="sidebar-toggle" />
        </div>
      </Col>
      <Col xxl="5" xl="6" lg="5" md="4" sm="3" className="left-header p-0">
        <div className="notification-slider overflow-hidden">
          <div className="d-flex h-100 align-items-center gap-2">
            <img src={logo} alt="" style={{ width: 28, height: 28, objectFit: 'contain' }} />
            <h6 className="mb-0 f-w-400">
              <span className="font-primary">RCATS </span>
              <span className="f-light">Royal Career &amp; Academic Tracking</span>
            </h6>
          </div>
        </div>
      </Col>
    </Fragment>
  );
}
